import { type DataTypeConfigType } from '@repo/utils';

import { ALL_DATA_TYPES, type DataTypeType } from './dataTypes';

export const FILTERABLE_ENTITY_TYPES = {
  leadActivity: 'lead_activity',
  taskType: 'task_type',
  salesGroup: 'sales_group',
  leadAttribute: 'lead_attributes',
  activityAttribute: 'activity_attributes',
} as const;

export type FilterableEntityTypes = typeof FILTERABLE_ENTITY_TYPES[keyof typeof FILTERABLE_ENTITY_TYPES];

export type BaseOptionsType = {
  value: string;
  label: string;
  // schemaName will determine the suffix for Server Condition Key
  schemaName: string;
  dataType: DataTypeType;
  // conditionKeyPrefix will be used as prefix for the condition key
  conditionKeyPrefix?: string;
  // Entity Key is Used to Determine the Item's Entity (Activity | lead | salesGroup)
  // if `conditionKeyPrefix` is not provided, entity key will be used as prefix
  entityType: FilterableEntityTypes;
  hasSubCondition?: boolean;
  hasDateFilter?: boolean;
  disabled?: boolean;
  dataTypeConfig?: Partial<DataTypeConfigType>;
  filterVisibleConditionValues?: (options: { value: string; label: string }[]) => { value: string; label: string }[];
};

export const LEAD_ACTIVITY_CONDITION_KEY = {
  value: FILTERABLE_ENTITY_TYPES.leadActivity,
  label: 'Lead Activity',
  schemaName: 'activity_id',
  dataType: ALL_DATA_TYPES.default,
  hasSubCondition: true,
  hasDateFilter: true,
  entityType: FILTERABLE_ENTITY_TYPES.leadActivity,
  disabled: false,
};

export const SALES_GROUP_CONDITION_KEY = {
  value: FILTERABLE_ENTITY_TYPES.salesGroup,
  label: 'Sales Group',
  schemaName: 'sales_group',
  dataType: ALL_DATA_TYPES.multi_select,
  entityType: FILTERABLE_ENTITY_TYPES.salesGroup,
  disabled: false,
};

export const TASK_TYPE_CONDITION_KEY = {
  value: FILTERABLE_ENTITY_TYPES.taskType,
  label: 'Task',
  schemaName: 'task_type',
  dataType: ALL_DATA_TYPES.default,
  hasSubCondition: true,
  hasDateFilter: false,
  entityType: FILTERABLE_ENTITY_TYPES.taskType,
  disabled: false,
};

export const CONDITION_KEY_OPTIONS: BaseOptionsType[] = [
  LEAD_ACTIVITY_CONDITION_KEY,
  TASK_TYPE_CONDITION_KEY,
  SALES_GROUP_CONDITION_KEY,
];

export const BASE_COMPARATOR_OPTIONS = {
  and: 'AND',
  or: 'OR',
} as const;

export const NON_FILTERABLE_ACTIVITY_KEYS = [
  'CreatedById',
  'ModifiedById',
  'ActivityTime',
];

export const NON_FILTERABLE_LEAD_ATTRIBUTES = [
  'LeadAge',
  'OwnerIdEmailAddress',
];

export type BaseOperatorType = typeof BASE_COMPARATOR_OPTIONS[keyof typeof BASE_COMPARATOR_OPTIONS];
